import { PaymentMethodEnum, type ExcludeOtherPaymentMethod } from '@/types/common';

/**
 * Identity of the form currently on screen. A new key clears `isUnavailable`
 * so chrome (Pay with, disclaimer) returns for the next method.
 *
 * OTHER includes the inner APM because Klarna → Amazon is a different form.
 * Tax-info only applies when the selected method is not OTHER.
 */
export const getAvailabilityResetKey = ({
  paymentMethodSelected,
  otherMethodSelected,
  blockedForZipCode,
}: {
  paymentMethodSelected: PaymentMethodEnum;
  otherMethodSelected?: ExcludeOtherPaymentMethod;
  blockedForZipCode: boolean;
}): string => {
  if (paymentMethodSelected === PaymentMethodEnum.OTHER) {
    return `${paymentMethodSelected}:${otherMethodSelected ?? ''}`;
  }
  if (blockedForZipCode) {
    return 'tax-info';
  }
  return paymentMethodSelected;
};
